const { Component } = wp.element;

const CustomResult = ({ result, hit }) => {
	const dateObj = new Date(hit._source.post_date);
	const dateFormat = dateObj.toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: '2-digit' });
	return(
		<div class="col-items style-featured col-md-4 col-sm-6 item-clearfix">
			<article>
				{hit._source.thumbnail && (
					<figure>
						<a href={hit._source.permalink} class="hover_border" aria-label={hit._source.post_title}>
							<img width={hit._source.thumbnail.width} height={hit._source.thumbnail.height} src={hit._source.thumbnail.src} class="img-responsive" alt={hit._source.post_title} />	
						</a>
						<a class="cat-label" href={hit._source.permalink} alt-label={hit._source.post_title}>
							{hit._source.terms.category[0].name}
						</a>
					</figure>
				)}
				<div class="date-publish">Published {dateFormat}</div>
				<header>
					<h3 class="entry-title">
						<a href={hit._source.permalink}>
							{hit._source.post_title}
						</a>
					</h3>
				</header>
			</article>
		</div>
	)
};
wp.hooks.addFilter('ep.InstantResults.Result', 'customResult', () => CustomResult);
